import React from 'react';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  SALON_PUBLIC_LAYOUT_REGISTRY,
  SALON_SERVICE_COLUMN_OPTIONS,
} from '../../../theme/salonPublicLayout';
import SalonLayoutOptionGroup from './SalonLayoutOptionGroup';


const firstError = (error) => (Array.isArray(error) ? error[0] : error || '');

const SalonContentLayoutControls = ({
  value,
  errors = {},
  onChange,
  disabled = false,
  registerFieldRef = () => {},
}) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2.5}>
      {Object.entries(SALON_PUBLIC_LAYOUT_REGISTRY.content).map(([axis, values]) => (
        <React.Fragment key={axis}>
          <SalonLayoutOptionGroup
            legend={t(`salon_theme.layout.content.${axis}.legend`)}
            name={`salon-layout-content-${axis}`}
            value={value?.[axis]}
            options={values.map((optionValue) => ({
              value: optionValue,
              label: t(`salon_theme.layout.content.${axis}.options.${optionValue}`),
            }))}
            onChange={(nextValue) => onChange(axis, nextValue)}
            disabled={disabled}
            error={firstError(errors?.[axis])}
            focusRef={(element) => registerFieldRef(axis, element)}
            selectedLabel={t('salon_theme.layout.selected')}
          />
          {axis === 'services' && value?.services === 'grid' && (
            <SalonLayoutOptionGroup
              legend={t('salon_theme.layout.content.service_columns.legend')}
              name="salon-layout-content-service-columns"
              value={value?.service_columns ?? 3}
              options={SALON_SERVICE_COLUMN_OPTIONS.map((columns) => ({
                value: columns,
                label: t(
                  `salon_theme.layout.content.service_columns.options.${columns}`,
                ),
              }))}
              onChange={(columns) => onChange('service_columns', columns)}
              disabled={disabled}
              error={firstError(errors?.service_columns)}
              focusRef={(element) => registerFieldRef(
                'service_columns',
                element,
              )}
              selectedLabel={t('salon_theme.layout.selected')}
            />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default SalonContentLayoutControls;
